
import { mapActions, mapMutations, mapState} from 'vuex'
import Previewer from 'vux/src/components/previewer/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import url from 'url'
import _ from 'lodash'
import moment from 'moment'
import imgSrc from '../assets/javascripts/imgSrc'
import canvas from '../assets/javascripts/canvas'

let bullets = [
{
text: '体态报告预览，付费查看详情',
bulletClassName: 'pagination-bullet font-12',
containerClassName: '',
iconClassName: ''
},
];

export default {
name: "face",
directive: {
},
components: {
swiper,
swiperSlide,
Previewer,
Loading,
},
data() {
return {
valid: true,
loading: true,
reportData: {},
customer: {},
swiperOption: {
pagination: {
el: '.posture-swiper-pagination',
clickable: true,
renderBullet(index, className) {
return `<div class="content-row content-row-column content-align-center content-row-around ${bullets[index].containerClassName} ${className}">` +
`<span class="${bullets[index].bulletClassName}">${bullets[index].text}</span>` +
`</div>`
}
},
},
normalRisks: [],
mildRisks: [],
severeRisks: [],
symptoms: {
head: [
{
name: '头部侧倾',
key: 'headSidesway',
normal: imgSrc.risk_normal.HEAD_SIDESWAY,
abnormal: imgSrc.risk_abnormal.HEAD_SIDESWAY,
definition: '在直立过程中，头部向左或右倾斜的现象。',
harm: {
bone: '颈椎侧屈',
muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
}
},
{
name: '头部前倾',
key: 'headLean',
normal: imgSrc.risk_normal.HEAD_LEAN,
abnormal: imgSrc.risk_abnormal.HEAD_LEAN,
definition: '头部过度向前伸的现象。',
harm: {
bone: '椎弓变直或出现反弓',
muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
}
}
],
shoulder: [
{
name: '高低肩',
key: 'highLowShoulder',
normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER,
abnormal: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER,
definition: '肩峰左右高度差超过2CM则为高低肩。',
harm: {
bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
neurovascular: '',
des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
}
},
{
name: '圆肩',
key: 'roundShoulder',
normal: imgSrc.risk_normal.ROUND_SHOULDER,
abnormal: imgSrc.risk_abnormal.ROUND_SHOULDER,
definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
harm: {
bone: '肩胛骨外展、胸廓变小',
muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
neurovascular: '',
des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
}
}
],
trunk: [
{
name: '脊柱侧弯',
key: 'spineSidesway',
normal: imgSrc.risk_normal.SPINE_SIDESWAY,
abnormal: imgSrc.risk_abnormal.SPINE_SIDESWAY,
definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
harm: {
bone: '脊柱出现S型弯曲或C型弯曲',
muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
neurovascular: '',
des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
}
}
],
pelvis: [
{
name: '骨盆侧倾',
key: 'pelvisLean',
normal: imgSrc.risk_normal.PELVIS_LEAN,
abnormal: imgSrc.risk_abnormal.PELVIS_LEAN,
definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
harm: {
bone: '骨盆倾斜',
muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
neurovascular: '',
des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
}
}
],
"lower extremity": [
{
name: 'O型腿',
key: 'legO',
normal: imgSrc.risk_normal.LEG_O,
abnormal: imgSrc.risk_abnormal.LEG_O,
definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
harm: {
bone: 'O型腿（膝内翻）',
muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
neurovascular: '',
des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
}
},
{
name: 'X型腿',
key: 'legX',
normal: imgSrc.risk_normal.LEG_X,
abnormal: imgSrc.risk_abnormal.LEG_X,
definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
harm: {
bone: 'X型腿（膝外翻）',
muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
neurovascular: '',
des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
}
},
{
name: '膝过伸',
key: 'kneeOverstretch',
normal: imgSrc.risk_normal.KNEE_OVERSTRETCH,
abnormal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH,
definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
harm: {
bone: '踝关节背屈不足，使膝关节无法向前移动',
muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
neurovascular: '',
des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
}
},
{
name: 'XO型腿',
key: 'legXO',
normal: imgSrc.risk_normal.LEG_X,
abnormal: imgSrc.risk_abnormal.LEG_X,
definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
harm: {
bone: '这个是XO型腿',
muscle: '这个是XO型腿',
neurovascular: '',
des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
}
},
],
},
level: {
normal: 'normal',
mild: 'mild',
severe: 'severe'
},
risks: {},
points: null,
photos: null,
coverInfo: {},
modalInfo: null,
}
},
computed: {
swiper() {
return this.$refs.postureSwiper.swiper
}
},
methods: {
getLevel(level) {
switch(level) {
case this.level.normal:
return {
des: '低风险',
className: 'level-normal'
};
case this.level.mild:
return {
des: '中风险',
className: 'level-mild'
};
case this.level.severe:
return {
des: '高风险',
className: 'level-severe'
};
}
},
checkIfAbnormal(level) {
switch(level) {
case this.level.normal:
return false
case this.level.mild:
return false
case this.level.severe:
return true
}
},
sortHighToLow(arr) {
return _.orderBy(arr, ['value'], ['desc'])
},
slideIn() {
this.swiper.slideTo(1)
},
initRisksData() {
let risks = this.risks;
let level = this.level;
let symptoms = this.symptoms;
let normalRisks = [];
let mildRisks = [];
let severeRisks = [];

for(let direction in risks) {
for (let i = 0; i < risks[direction].length; i++) {
let symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

if (symptom.value) {
let otherSymptom = Object.assign({}, symptom);
if(!risks[direction][i].valid) {
otherSymptom.raw = 0;
otherSymptom.value = 0;
otherSymptom.level = level.normal;
otherSymptom.detail = '';
} else {
otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
}

symptoms[risks[direction][i].position].push(otherSymptom);
} else {
if(!risks[direction][i].valid) {
symptom.raw = 0;
symptom.value = 0;
symptom.level = level.normal;
symptom.detail = '';
} else {
symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
}
}
}
}

for(let position in symptoms) {
for(let i = 0; i < symptoms[position].length; i++) {
if(_.isUndefined(symptoms[position][i].value)) {
continue;
}
switch(symptoms[position][i].level) {
case level.normal:
normalRisks.push(symptoms[position][i]);
break;
case level.mild:
mildRisks.push(symptoms[position][i]);
break;
case level.severe:
severeRisks.push(symptoms[position][i]);
break;
default:
normalRisks.push(symptoms[position][i]);
break;
}
}
}

this.normalRisks = this.sortHighToLow(normalRisks);
this.mildRisks = this.sortHighToLow(mildRisks);
this.severeRisks = this.sortHighToLow(severeRisks);
console.log('normalRisks =>', normalRisks);
console.log('mildRisks =>', mildRisks);
console.log('severeRisks =>', severeRisks);
},
initRiskPoints() {
let points = this.points;
let photos = this.photos;
let faceCanvas = document.createElement('canvas');
let sideCanvas = document.createElement('canvas');
let _this = this;


let facePointsArr = [];
let face = points.face;
let faceImg = new Image();




let hipRPoint = face['hip']['right'];
let hipLPoint = face['hip']['left'];
let neckPoint = face['neck']
let hipMPoint = {
x: 0,
y: 0
};
let hipAndNeckMPoint = {
x: 0,
y: 0
};
if((hipLPoint.x == 0 && hipLPoint.y == 0) || (hipRPoint.x == 0 && hipRPoint.y == 0)) {

} else {

hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;


if(!(neckPoint.x == 0 && neckPoint.y == 0)) {
hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2;
hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2;
}

};

face.hipM = hipMPoint;
face.hipAndNeckM = hipAndNeckMPoint;

let faceOrder = [
['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'],
['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'],

['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'],
['neck', 'hipAndNeckM', 'hipM'],
['nose', 'neck']
];


let verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left'];
let verticalPointsArr = [];


let risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

console.log('risks =>', risks);
let faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee']
let faceHorizontalArr = [];

for(let i = 0; i < faceSymptomWithPosition.length; i++) {
let symptomWithPositionArr = faceSymptomWithPosition[i].split('-');
let pointsAndAngle = {
key: symptomWithPositionArr[0]
};

for(let j = 0; j < risks.length; j++) {
if(risks[j].key == symptomWithPositionArr[0]) {
if(!_.isUndefined(pointsAndAngle.raw)) {
pointsAndAngle.secondRaw = risks[j].raw;
} else {
pointsAndAngle.raw = risks[j].raw;
if(symptomWithPositionArr.length == 1) {
pointsAndAngle.points = [face['elbow'].left]
} else {
pointsAndAngle.points = [face[symptomWithPositionArr[1]].right, face[symptomWithPositionArr[1]].left]
}
}
}
}

if(_.isUndefined(pointsAndAngle.raw) || _.isUndefined(pointsAndAngle.points)) {
continue;
} else {
faceHorizontalArr.push(pointsAndAngle)
}
}

console.log('faceHorizontalArr =>', faceHorizontalArr);


for(let i = 0; i < faceOrder.length; i++) {
let pointsArr = [];
for(let j = 0; j < faceOrder[i].length; j++) {
let positionArr = faceOrder[i][j].split('-');
if(positionArr.length == 1) {
pointsArr.push(face[positionArr[0]]);
} else {
pointsArr.push(face[positionArr[0]][positionArr[1]])
}
}
facePointsArr.push(pointsArr)
}


for(let i = 0; i < verticalStandard.length; i++) {
let positionArr = verticalStandard[i].split('-');









if(positionArr[1] == 'middle') {
if((face[positionArr[0]].left.x == 0 && face[positionArr[0]].left.y == 0) || (face[positionArr[0]].right.x == 0 && face[positionArr[0]].right.y == 0)) {
verticalPointsArr.push({
x: 0,
y: 0
})
} else {
verticalPointsArr.push({
x: (face[positionArr[0]].left.x + face[positionArr[0]].right.x) / 2,
y: 0
})
}
} else {
verticalPointsArr.push(face[positionArr[0]][positionArr[1]]);
}
}

console.log('verticalPointsArr =>', verticalPointsArr);


faceImg.src = photos.face;
faceImg.onload = function () {

let width = faceImg.width;
let height = faceImg.height;
faceCanvas.width = width;
faceCanvas.height = height;
faceCanvas.style.width = '100%';

let cxt = faceCanvas.getContext('2d');
cxt.drawImage(faceImg, 0, 0, width, height);


for(let i = 0; i < facePointsArr.length; i++) {
for(let j = 0; j < facePointsArr[i].length; j++) {
if(j == 0 || (facePointsArr[i][j].x == 0 && facePointsArr[i][j].y == 0) || (facePointsArr[i][j-1].x == 0 && facePointsArr[i][j-1].y == 0)) {
if(facePointsArr[i][j].x == 0 && facePointsArr[i][j].y == 0) {
continue;
} else {
_this.drawPoint({
el: faceCanvas,
point: facePointsArr[i][j]
});
continue;
}
} else {
_this.drawPoint({
el: faceCanvas,
point: facePointsArr[i][j]
});
_this.drawLine({
el: faceCanvas,
points: [facePointsArr[i][j], facePointsArr[i][j-1]]
})
}
}
}


for(let i = 0; i < verticalPointsArr.length; i++) {
if(verticalPointsArr[i].x == 0 && verticalPointsArr[i].y == 0) {
continue;
} else {
cxt.save();
cxt.strokeStyle = '#4db664';
cxt.beginPath();
cxt.moveTo(verticalPointsArr[i].x, 0);
cxt.lineTo(verticalPointsArr[i].x, height);
cxt.closePath();
cxt.stroke();
cxt.restore();

cxt.save();
cxt.fillStyle = '#fe610f';
cxt.font = '30px serif';
let window_width = document.documentElement.clientWidth;
let window_height = window.screen.height;
let offset_height = (window_height - 125) / (window_width / width);
if(i == 0) {
cxt.fillText('α', verticalPointsArr[i].x + 5, offset_height - 5)
} else if(i == verticalPointsArr.length -1) {
cxt.fillText('γ', verticalPointsArr[i].x + 5, offset_height - 5)
} else {
cxt.fillText('β', verticalPointsArr[i].x + 5, offset_height - 5)
}
cxt.restore();
}
}


let min = 99999;
let max = 0;
let indexOfKneeArr = [];
for(let i = 0; i < faceHorizontalArr.length; i++) {
if(faceHorizontalArr[i].points.length !== 1){
if((faceHorizontalArr[i].points[0].x == 0 && faceHorizontalArr[i].points[0].y == 0) || faceHorizontalArr[i].points[1].x == 0 && faceHorizontalArr[i].points[1].y == 0) {
continue;
}
if(faceHorizontalArr[i].points[0].x < min) {
min = faceHorizontalArr[i].points[0].x;
}
if(faceHorizontalArr[i].points[1].x > max) {
max = faceHorizontalArr[i].points[1].x
}
}

if(faceHorizontalArr[i].key == 'legX' || faceHorizontalArr[i].key == 'legO' || faceHorizontalArr[i].key == 'legXO') {
indexOfKneeArr.push(i)
}
}


if(indexOfKneeArr.length == 2) {
faceHorizontalArr[indexOfKneeArr[0]].secondRaw = faceHorizontalArr[indexOfKneeArr[1]].raw;
faceHorizontalArr.splice(indexOfKneeArr[1], 1)
}

for(let i = 0; i < faceHorizontalArr.length; i++) {
_this.drawLineAndAngle({
el: faceCanvas,
angle: faceHorizontalArr[i].raw,
secondAngle: faceHorizontalArr[i].secondRaw,
points: faceHorizontalArr[i].points,
min: min,
max: max
})
}

_this.$nextTick(function () {
document.getElementById('face').appendChild(faceCanvas)
});
};

},
drawPoint(option) {
let canvas = option.el;
let point = option.point;
let cxt = canvas.getContext('2d');
cxt.save();
cxt.fillStyle = '#009eff';
cxt.beginPath();
cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
cxt.closePath();
cxt.fill();
cxt.restore();
cxt.save();
cxt.fillStyle = "rgba(83, 158, 255, .3)";
cxt.beginPath();
cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
cxt.closePath();
cxt.fill();
cxt.restore();
},
drawLine(option) {

if((option.points[0].x == 0 && option.points[0].y == 0) || (option.points[1].x == 0 && option.points[1].y == 0)) {
return;
}
let canvas = option.el;
let points = option.points;
let cxt = canvas.getContext('2d');
cxt.save();
cxt.lineWidth = 3;
if(!option.isSide) {
cxt.strokeStyle = '#5f58f4';
cxt.beginPath();
cxt.moveTo(points[0].x, points[0].y);
cxt.lineTo(points[1].x, points[1].y);
cxt.closePath();
cxt.stroke();
} else {
let _x = Math.abs(points[0].x - points[1].x);
let _y = Math.abs(points[0].y - points[1].y);
let z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
let startX;
let startY;
let endX;
let endY;
let distance = 80;

console.log('points ===>', points)
if(points[0].x > points[1].x) {
startX = Math.round(points[1].x - distance * _x / z);
startY = Math.round(points[1].y + distance * _y / z);
endX = Math.round(points[0].x + distance * _x / z);
endY = Math.round(points[0].y - distance * _y / z);
} else {
startX = Math.round(points[0].x - distance * _x / z);
startY = Math.round(points[0].y - distance * _y / z);
endX = Math.round(points[1].x + distance * _x / z);
endY = Math.round(points[1].y + distance * _y / z);
}

cxt.strokeStyle = '#0ef8cd';
cxt.beginPath();
cxt.moveTo(startX, startY);
cxt.lineTo(endX, endY);
cxt.closePath();
cxt.stroke();
}

cxt.restore();
},
drawRectAndAngle(option) {
let cxt = option.cxt;
let angle = option.angle;
let point = option.point;

cxt.save();
if(option.isSecond) {
cxt.translate(0, 43)
}
cxt.save();
cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
cxt.beginPath();
cxt.moveTo(point.x + 13, point.y + 3);
cxt.lineTo(point.x + 99, point.y + 3);
cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
cxt.lineTo(point.x + 109, point.y + 33);
cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
cxt.lineTo(point.x + 13, point.y + 43);
cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
cxt.lineTo(point.x + 3, point.y + 13);
cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
cxt.closePath();
cxt.fill();
cxt.restore();


cxt.save();
cxt.font = '34px Arial';
cxt.fillStyle = '#0cfcca';
cxt.textAlign = 'center';
if(option.isTrunk) {
cxt.fillText(`${angle}%`, point.x + 56, point.y + 38);
} else {
cxt.fillText(`${angle}°`, point.x + 56, point.y + 38);
}
cxt.restore();
cxt.restore();
},
drawLineAndAngle(option){
let canvas = option.el;
let width = canvas.width;
let points = option.points;
let min = option.min - 100;
let max = option.max + 100;
let cxt = canvas.getContext('2d');


for(let i = 0; i < points.length; i++) {
if(points[i].x == 0 && points[i].y == 0) {
return;
}
}


console.log('======== point', points);
if(points.length == 1) {
this.drawRectAndAngle({
cxt: cxt,
angle: (option.angle * 100).toFixed(1),
point: {
x: width - 120,
y: points[0].y
},
isSecond: false,
isTrunk: true
})
} else {
let _x = Math.abs(points[0].x - points[1].x);
let _y = Math.abs(points[0].y - points[1].y);
let startPoint = {};
let endPoint = {};
let offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
let offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

if(points[0].y < points[1].y) {
startPoint.x = min;
startPoint.y = points[0].y - offsetYL;
endPoint.x = max;
endPoint.y = points[1].y + offsetYR;
} else {
startPoint.x = min;
startPoint.y = points[0].y + offsetYL;
endPoint.x = max;
endPoint.y = points[1].y - offsetYR;
}

cxt.save();
cxt.strokeStyle = '#14bc9a';
cxt.beginPath();
cxt.moveTo(startPoint.x, startPoint.y);
cxt.lineTo(endPoint.x, endPoint.y);
cxt.closePath();
cxt.stroke();
cxt.restore();


this.drawRectAndAngle({
cxt: cxt,
angle: Number(option.angle.toFixed(1)),
point: {
x: width - 120,
y: points[1].y
},
isSecond: false
});
console.log('secondAngle =>', option.secondAngle);
if(!_.isUndefined(option.secondAngle)) {
this.drawRectAndAngle({
cxt: cxt,
angle: Number(option.secondAngle.toFixed(1)),
point: {
x: width - 120,
y: points[1].y
},
isSecond: true
});
}
}
},
...mapState({
initReportData(state) {
let reportData = state.vux.reportData;
let _this = this;
if(_.isNull(reportData)) {
let uuid = '';
let type = '';

let urlquery = url.parse(window.location.href).query;
let query = urlquery.split('&');
for (let every = 0; every < query.length; every++) {
if (query[every].indexOf('uuid=') != -1) {
uuid = query[every].replace('uuid=', '');
}
if (query[every].indexOf('type=') != -1) {
type = query[every].replace('type=', '');
}
}

this.get({
url: `v1/posture/reports/${uuid}`,
params: {
type: type
},
success(result) {
_this.updateReportData({
reportData: result
});
_this.getReportData();
console.log('result=>', result)
},
error(data) {
_this.loading = false;
_this.valid = false
}
})
} else {
_this.getReportData();
}
},
getReportData(state) {
this.loading = false;
let reportData = state.vux.reportData;


this.conclusion = reportData.conclusion;
let conclusion = this.conclusion;
if(!conclusion.face.valid || !conclusion.side.valid) {
this.valid = false
} else {
this.risks = {
face: conclusion.face.risks,
side: conclusion.side.risks
}
this.initRisksData();
}


let points = {
face: conclusion.face.points,
side: Object.assign(conclusion.side.points, {side: conclusion.side.side})
};
this.points = points;

console.log('all points =>', points);

let photos = {
face: reportData.face,
side: reportData.side
};
this.photos = photos

this.initRiskPoints()
},
}),
...mapActions(['get']),
...mapMutations(['updateReportData'])
},
created() {
this.initReportData();
},
}



// WEBPACK FOOTER //
// ./src/components/Face.vue